import { render } from "./ModalView.vue?vue&type=template&id=c2d1f324&scoped=true"
import script from "./ModalView.vue?vue&type=script&lang=js"
export * from "./ModalView.vue?vue&type=script&lang=js"

import "./ModalView.vue?vue&type=style&index=0&id=c2d1f324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d1f324"]])

export default __exports__